import { $, dataExist, siblings, translationGuard } from '../utils/Utils';
import endPoint from '../utils/end-points';

require('es6-promise').polyfill();
const axios = require('axios');

const formJobSubscribe = (() => {
  const config = {
    triggers: [...$('.js-formJobSubscribeTrigger')],
    triggerCN: 'js-formJobSubscribeTrigger',
    submit: '.js-formJobSubscribeSubmit',
    successDiv: '.js-formJobSubscribeSuccess',
    closeButton: $('.js-formJobSubscribeClose'),
    modalDismiss: '.js-lightboxDismiss',
    input: '.js-inputTrigger',
    parentCN: 'js-inputParent',
    helperCN: 'js-inputHelper',
    errorCN: 'js-errorBox',
    invalidCN: '-invalid',
    hasErrorsCN: '-has-errors',
  };

  const updateSubmitBtn = ({ trigger: t, status = 'processing' }) => {
    const submitBtn = t.querySelector(config.submit);

    if (submitBtn) {
      let txt;
      submitBtn.classList.remove('-progress');

      switch (status) {
        case 'initial':
          submitBtn.removeAttribute('disabled');
          txt = submitBtn.dataset.initial;
          break;
        case 'error':
          submitBtn.removeAttribute('disabled');
          txt = submitBtn.dataset.error;
          break;
        case 'done':
          txt = submitBtn.dataset.initial;
          break;
        case 'hidden':
          txt = submitBtn.dataset.initial;
          submitBtn.classList.add('-hide');
          break;
        case 'visible':
          txt = submitBtn.dataset.initial;
          submitBtn.classList.remove('-hide');
          submitBtn.removeAttribute('disabled');
          break;
        default:
          submitBtn.setAttribute('disabled', true);
          submitBtn.classList.add('-progress');
          txt = submitBtn.dataset.processing;
          break;
      }

      submitBtn.textContent = txt;
    }
  };

  const errors = {
    reset(t) {
      // get all the inputs with errors
      const inputWithErrors = [...t.querySelectorAll(`${config.input}.${config.invalidCN}`)];
      const errorBox = t.querySelector(`.${config.errorCN}`);
      if(errorBox) {
        errorBox.innerHTML = '';
        errorBox.classList.remove(config.hasErrorsCN);
      }

      inputWithErrors.forEach((input) => {
        const helper = input.previousElementSibling.querySelector('span.' + config.helperCN);
        // const helper = siblings.find({ filter: config.helperCN, sibling: input })[0];
        // remove error class
        input.classList.remove(config.invalidCN);
        // remove text
        helper.innerHTML = '';
      });
    },
    handle({ trigger: t, arr }) {
      console.log(t);
      let errorText = "";
      let errorCount = 0;
      arr.forEach((err) => {
        errorCount = errorCount + 1;
        const input = t.querySelector(`[name='${err.field}']`);
        const helper = input.previousElementSibling.querySelector('span.' + config.helperCN);
        // const helper = siblings.find({ filter: config.helperCN, sibling: input })[0];
        // change input state
        input.classList.add(config.invalidCN);
        // add text
        helper.innerHTML = translationGuard(err.message);
        errorText = errorText + '<li>' + translationGuard(err.message) + '</li>';
      });
      if(errorCount > 0) {
        const errorBox = t.querySelector(`.${config.errorCN}`);
        console.log(errorBox);

        if(errorBox) {
          errorBox.innerHTML = "<p>Formuläret innehåller " + errorCount + " fel</p><ul>" + errorText + "</ul>";
          errorBox.classList.add(config.hasErrorsCN);
        }
      }
    },
  };

  const successDiv = {
    show({ trigger, message }) {
      const s = trigger.querySelector(config.successDiv);
      s.classList.add('-show');
      s.setAttribute('aria-hidden', 'false');
      s.innerHTML = `<h3>${translationGuard(message.title)}</h3><p>${translationGuard(message.body)}</p>`;
    },
    hide({ trigger }) {
      const s = trigger.querySelector(config.successDiv);
      s.classList.remove('-show');
    },
  };

  const handleFormInputs = (trigger, show) => {
    trigger.querySelectorAll('.input__group').forEach((elem) => {
      /* eslint-disable no-unused-expressions */
      show ? elem.classList.remove('-hide') : elem.classList.add('-hide');
    });
  };

  const resetForm = (trigger) => {
    handleFormInputs(trigger, true);

    trigger.reset();
    const t = trigger.querySelector(config.successDiv);
    t.innerHTML = '';
    t.classList.remove('-show');

    updateSubmitBtn({ trigger, status: 'visible' });
    config.closeButton[0].classList.add('-hide');
  };

  const handleSuccess = ({ trigger, message }) => {
    successDiv.show({ trigger, message });
    updateSubmitBtn({ trigger, status: 'hidden' });

    handleFormInputs(trigger, false);
    config.closeButton[0].classList.remove('-hide');
  };

  const handleSubmit = ({ trigger, e }) => {
    const formData = new FormData(trigger);
    // prevent action
    e.preventDefault();
    // deal with Submit button
    updateSubmitBtn({ trigger });

    // reset all error messages from the form
    errors.reset(trigger);

    axios
      .post(endPoint.subscribeJobs, formData)
      .then((response) => { // response
        if (dataExist(response, 'data')) {
          if (dataExist(response.data, 'message')) {
            handleSuccess({ trigger, message: response.data.message });
          }
        }
      })
      .catch((error) => {
        // show correct message on submit button
        updateSubmitBtn({ trigger, status: 'error' });

        // show error message
        if (dataExist(error, 'response')) {
          if (dataExist(error.response, 'data')) {
            errors.handle({ trigger, arr: error.response.data.errors });
          }
        }
      });
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.addEventListener('submit', e => handleSubmit({ trigger, e }));
    });

    if (config.closeButton.length > 0) {
      config.closeButton[0].addEventListener('click', () => {
        const modalDismissBtn = document.querySelector(config.modalDismiss);

        if (modalDismissBtn) {
          modalDismissBtn.click();
          resetForm(config.triggers[0]);
        }
      });
    }
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default formJobSubscribe.init();
